import {
  EditorAPIKey,
  EditorCoreApiKey,
  PanelManagerApiKey,
} from '#packages/apis';
import { BaseEntryScope } from '#packages/apilib';

export class RtlLtrSettingsManagerScope extends BaseEntryScope {
  editorCoreAPI = this.useDependency(EditorCoreApiKey);
  editorAPI = this.useDependency(EditorAPIKey);
  panelManagerApi = this.useDependency(PanelManagerApiKey);
}
